function initGsapAnimations() {
	if (typeof gsap === "undefined") {
		return;
	}

	if (typeof ScrollTrigger !== "undefined") {
		gsap.registerPlugin(ScrollTrigger);
	}

	const revealNodes = document.querySelectorAll("[data-lg-reveal]");
	revealNodes.forEach((element, index) => {
		const revealType = element.getAttribute("data-lg-reveal");
		const delay = index * 0.03;
		const from = { opacity: 0, y: 24 };

		if (revealType === "fade-to-left") {
			from.x = -40;
			from.y = 0;
		}

		if (revealType === "fade-to-right") {
			from.x = 40;
			from.y = 0;
		}

		if (revealType === "fade-to-top") {
			from.y = 30;
		}

		gsap.fromTo(
			element,
			from,
			{
				opacity: 1,
				x: 0,
				y: 0,
				duration: 0.8,
				delay,
				ease: "power2.out",
				overwrite: "auto",
				scrollTrigger: {
					trigger: element,
					start: "top 88%",
					toggleActions: "play none none none",
					once: true,
				},
			},
		);
	});

	const parallaxNodes = document.querySelectorAll("[data-lg-parallax]");
	parallaxNodes.forEach((element) => {
		const amplitude = Number.parseFloat(element.getAttribute("data-lg-parallax-amplitude")) || 0.15;
		const inertia = Number.parseFloat(element.getAttribute("data-lg-parallax-inertia")) || 0.2;

		gsap.to(element, {
			yPercent: amplitude * 100,
			ease: "none",
			overwrite: "auto",
			scrollTrigger: {
				trigger: element,
				start: "top bottom",
				end: "bottom top",
				scrub: Math.max(0.1, inertia * 10),
			},
		});
	});
}

window.initGsapAnimations = initGsapAnimations;